// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__OAU+C","outside":"Modal_outside__fAYbe"};